import axios from 'axios';
import logErrorForCloudWatch from '../awsCloudwatchLogs';
import dataModel from '../../models/DataModel';

function reloadSpaIfNeeded() {
    // check version
  if (process && process.env && process.env.REACT_APP_VERSION_URL) {
    axios({
      url: process.env.REACT_APP_VERSION_URL,
    }).then(async response => {
      if (response.data && response.data.version) {
        const expectedVersion = response.data.version;
        const actualVersion = process.env.VERSION;
        if (expectedVersion != actualVersion) {
          console.log('spa version change detected: ' + process.env.VERSION + ' != ' + response.data.version);
          const lastRefreshTimeFormatted = localStorage.lastRefreshTime ? new Date(+localStorage.lastRefreshTime) : 'none';
          if (!localStorage.lastRefreshTime || (Date.now() - localStorage.lastRefreshTime) > 300000) {
            const logObject = dataModel.buildDataModelErrorObjectForCloudwatch(`Spa reload triggered. Expected Version: ${expectedVersion}, Actual Version: ${actualVersion}, Last Reload Time: ${lastRefreshTimeFormatted}`, 'INFO');
            logErrorForCloudWatch(logObject);
            if (dataModel.mobileBridge && dataModel.mobileBridge.lastNavigateTo) {
              localStorage.lastNavigateTo = dataModel.mobileBridge.lastNavigateTo;
            }
            if (dataModel.storeManager) {
              console.log('resetting store');
              dataModel.storeManager.reset(+localStorage.loggedin_user_id, true, { ignoreCollections: false, clearDeprecated: false });
              await dataModel.persistor.flush();
            }
              // SETTING THIS DATE MUST BE THE LAST THING DONE BEFORE THE RELOAD! 
              // OTHERWISE WEIRD VERSION MISMATCHES CAN OCCUR IF CLIENT ERRORS ARE THROWN
            localStorage.lastRefreshTime = Date.now();
            if (window.cordova && window.cordova.initialHref) {
              console.log('reloading application using cordova ' + window.cordova.initialHref);
              window.location = window.cordova.initialHref;
            }
            else {
              console.log('reloading application using ' + window.location.href);
              window.location.reload(true);
            }
          }
          else {
            const logObject = dataModel.buildDataModelErrorObjectForCloudwatch(`Consecutive spa version mismatch within 5 minute period. Expected Version: ${expectedVersion}, Actual Version: ${actualVersion}, Last Reload Time: ${lastRefreshTimeFormatted}`, 'WARN');
            logErrorForCloudWatch(logObject);
          }
        }
      }
      else throw Object.assign({}, { text: 'invalid response format in version check!', data: response.data });
    }).catch(error => {
      throw error;
    });
  }
    // also try and get latest index.html
    // axios({
    //   url: process.env.REACT_APP_ASSET_URL,
    //   headers: {
    //     'Cache-Control': 'no-cache',
    //     'Pragma': 'no-cache'
    //   }
    // }).catch(error => {
    //   throw error
    // })
}
  
export default {
  reloadSpaIfNeeded,
};



// WEBPACK FOOTER //
// ./src/helpers/session/CacheUtil.js